import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=5b090f63&"
import script from "./Steps.vue?vue&type=script&lang=js&"
export * from "./Steps.vue?vue&type=script&lang=js&"
import style0 from "./Steps.vue?vue&type=style&index=0&id=5b090f63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports